'use strict';
import Vue from 'vue';
import App from './App';
import router from './router/index';
import i18n from '../../common/js/i18n';
import '../../common/js/style';
import 'babel-polyfill';
import '../../assets/iconfont/iconfont.css';
import ismobile from 'ismobilejs';

Vue.config.productionTip = false;
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    if (!ismobile.any) {
      location.href = './privacy.html';
    }
  }
});



// WEBPACK FOOTER //
// ./src/module/privacy_m/privacy_m.js